// Arabic strings for the demoguard stream — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until
// decision H-10.
import type { enDemoguard } from './en-demoguard.ts';
import type { Message } from './types.ts';

export const arDemoguard: { readonly [K in keyof typeof enDemoguard]: Message } = {
  // ------------------------------------------------------------ API (PD-725)
  'api.demoReadOnly': 'هذا عرض تجريبي: لا يتم حفظ التغييرات.',
  // ------------------------------------------------------------ banner and notices (PD-729, PD-730)
  'demo.banner': 'عرض تجريبي — لا يُحفظ ولا يُرسل أي شيء تقوم به',
  'demo.bannerRegion': 'وضع العرض التجريبي',
  'demo.notice.title': 'لم يُحفظ — هذا عرض تجريبي',
  'demo.notice.body': 'هذا عرض تجريبي: لا يتم حفظ التغييرات. ما أدخلته لا يزال موجوداً، فيمكنك مواصلة الاستكشاف.',
  'demo.notice.dismiss': 'إغلاق',
  // ------------------------------------------------------------ UAE PASS (PD-727)
  'ver.pass.demoUnavailable': 'تسجيل الدخول عبر الهوية الرقمية (UAE PASS) غير متاح في العرض التجريبي. في الموقع الفعلي يمكن التحقق من هويتك أيضاً لدى الاستقبال.',
  // ------------------------------------------------------------ console environment panel (PD-720)
  'set.env.demo': 'وضع العرض التجريبي (IS_DEMO)',
  'set.env.demoOn': 'مفعّل — للقراءة فقط، لا يُرسل أي شيء',
  'set.env.demoOff': 'غير مفعّل',
};
